(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["onebyone-home-inspiration"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const previewLimit = 8;
    const slotClasses = Array.from({ length: previewLimit }, (_, index) => `onebyone-home-inspiration__lookbook-item--${index + 1}`);

    const sortPreview = (grid) => {
      const items = Array.from(grid.querySelectorAll('[data-home-lookbook-item]')).sort((first, second) => {
        return Number(first.dataset.lookbookSort || 0) - Number(second.dataset.lookbookSort || 0);
      });

      items.forEach((item, index) => {
        item.classList.remove(...slotClasses);
        item.classList.add(slotClasses[Math.min(index, previewLimit - 1)]);
        item.toggleAttribute('data-home-lookbook-visible', index < previewLimit);

      });

      grid.append(...items);
    };

    document.querySelectorAll('[data-home-lookbook-preview]').forEach(sortPreview);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-home-lookbook-preview]').forEach(sortPreview);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebyone-home-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMotion.matches) return;

    const viewports = document.querySelectorAll('[data-onebyone-home-reviews-autoscroll]');
    const speed = 18;

    viewports.forEach((viewport) => {
      let frame = 0;
      let lastTimestamp = 0;
      let scrollPosition = 0;

      const stop = () => {
        if (frame) {
          window.cancelAnimationFrame(frame);
          frame = 0;
        }

        lastTimestamp = 0;
        viewport.removeAttribute('data-onebyone-home-reviews-autoscrolling');
      };

      const tick = (timestamp) => {
        if (!lastTimestamp) lastTimestamp = timestamp;

        const elapsed = Math.min(timestamp - lastTimestamp, 64);
        lastTimestamp = timestamp;

        const maxScroll = viewport.scrollWidth - viewport.clientWidth;

        if (maxScroll > 0) {
          scrollPosition += (elapsed / 1000) * speed;

          if (scrollPosition >= maxScroll - 1) {
            scrollPosition = 0;
          }

          viewport.scrollLeft = scrollPosition;
        }

        frame = window.requestAnimationFrame(tick);
      };

      const start = () => {
        stop();

        if (viewport.scrollWidth <= viewport.clientWidth) return;

        scrollPosition = viewport.scrollLeft;
        viewport.setAttribute('data-onebyone-home-reviews-autoscrolling', 'true');
        frame = window.requestAnimationFrame(tick);
      };

      viewport.addEventListener('pointerenter', stop);
      viewport.addEventListener('pointerleave', start);
      viewport.addEventListener('focusin', stop);
      viewport.addEventListener('focusout', start);
      viewport.addEventListener('touchstart', stop, { passive: true });
      viewport.addEventListener('touchend', () => window.setTimeout(start, 900), { passive: true });
      window.addEventListener('resize', () => window.setTimeout(start, 150));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebyone-lookbook-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initLookbookGallery = (gallery) => {
      const sectionId = gallery.dataset.lookbookSection;
      const dialog = document.querySelector(`[data-lookbook-dialog="${sectionId}"]`);

      if (!gallery || !dialog || gallery.dataset.lightboxReady === 'true') return;

      const grid = gallery.querySelector('.lookbook-gallery__grid');
      const items = Array.from(gallery.querySelectorAll('.lookbook-gallery__item')).sort((first, second) => {
        return Number(first.dataset.lookbookSort || 0) - Number(second.dataset.lookbookSort || 0);
      });
      const imageSlot = dialog.querySelector('[data-lookbook-image-slot]');
      const productSlot = dialog.querySelector('[data-lookbook-product-slot]');
      const counter = dialog.querySelector('[data-lookbook-counter]');
      const closeButton = dialog.querySelector('[data-lookbook-close]');
      let image = null;
      let activeIndex = 0;
      let activeTrigger = null;
      let lockedScrollY = 0;
      let touchStartX = 0;
      let touchStartY = 0;
      let closingFromHistory = false;

      if (!grid || !items.length || !imageSlot || !counter || !productSlot) return;

      items.forEach((item) => grid.appendChild(item));

      const itemUrl = (item) => {
        const link = item.querySelector('.lookbook-gallery__image-link');
        return item.dataset.lookbookFull || (link ? link.href : '');
      };
      const isMobileLookbookLightbox = () => window.matchMedia('(max-width: 760px)').matches;
      let mobileLightboxProductFrame = null;

      const clearMobileLightboxProductPosition = () => {
        productSlot.style.removeProperty('left');
        productSlot.style.removeProperty('top');
        productSlot.style.removeProperty('right');
        productSlot.style.removeProperty('bottom');
      };

      const positionMobileLightboxProduct = () => {
        if (!isMobileLookbookLightbox() || !dialog.open || productSlot.hidden || !image) {
          clearMobileLightboxProductPosition();
          return;
        }

        const imageRect = image.getBoundingClientRect();
        const productAnchorRect = imageSlot.getBoundingClientRect();
        const anchorRect = productAnchorRect.width && productAnchorRect.height ? productAnchorRect : imageRect;
        const slotRect = productSlot.getBoundingClientRect();
        const dialogRect = dialog.getBoundingClientRect();

        if (!imageRect.width || !imageRect.height || !slotRect.width || !slotRect.height) return;

        const inset = Math.max(10, Math.min(18, imageRect.width * 0.04));
        const minLeft = Math.max(dialogRect.left + 10, anchorRect.left + inset);
        const maxLeft = Math.max(minLeft, Math.min(window.innerWidth - slotRect.width - 10, anchorRect.right - slotRect.width - inset));
        const minTop = Math.max(dialogRect.top + 10, anchorRect.top + inset);
        const maxTop = Math.max(minTop, Math.min(window.innerHeight - slotRect.height - 10, anchorRect.bottom - slotRect.height - inset));
        const left = Math.min(Math.max(anchorRect.right - slotRect.width - inset, minLeft), maxLeft);
        const top = Math.min(Math.max(anchorRect.bottom - slotRect.height - inset, minTop), maxTop);

        productSlot.style.left = `${left - dialogRect.left}px`;
        productSlot.style.top = `${top - dialogRect.top}px`;
        productSlot.style.right = 'auto';
        productSlot.style.bottom = 'auto';
      };

      const scheduleMobileLightboxProductPosition = () => {
        if (mobileLightboxProductFrame !== null) cancelAnimationFrame(mobileLightboxProductFrame);
        mobileLightboxProductFrame = requestAnimationFrame(() => {
          mobileLightboxProductFrame = null;
          positionMobileLightboxProduct();
        });
      };

      window.addEventListener('resize', scheduleMobileLightboxProductPosition);
      window.addEventListener('orientationchange', scheduleMobileLightboxProductPosition);

      if ('ResizeObserver' in window) {
        new ResizeObserver(scheduleMobileLightboxProductPosition).observe(productSlot);
      }

      const getEditorialColumnFractions = () => {
        if (window.matchMedia('(max-width: 760px)').matches) return [1];
        if (window.matchMedia('(max-width: 1100px)').matches) return [1.08, 0.94, 1.02];
        return [1.06, 0.92, 1.16, 0.98];
      };

      const getGalleryProductFrameHeight = (item, itemWidth) => {
        if (!item.classList.contains('lookbook-gallery__item--has-product')) return 0;
        return itemWidth * 1.5;
      };

      const getEditorialItemHeight = (item, itemWidth) => {
        const photo = item.querySelector('.lookbook-gallery__image-link > img, img');
        let itemHeight = itemWidth;

        if (photo) {
          if (photo.naturalWidth > 0 && photo.naturalHeight > 0) {
            itemHeight = itemWidth * (photo.naturalHeight / photo.naturalWidth);
          } else {
            const measured = photo.getBoundingClientRect();

            if (measured.width > 0 && measured.height > 0) {
              itemHeight = itemWidth * (measured.height / measured.width);
            } else {
              itemHeight = itemWidth * 1.32;
            }
          }
        }

        return Math.max(itemHeight, getGalleryProductFrameHeight(item, itemWidth));
      };

      const layoutEditorialMasonry = () => {
        const gridStyle = getComputedStyle(grid);
        const gridWidth = grid.getBoundingClientRect().width;
        const gap = parseFloat(gridStyle.getPropertyValue('--lookbook-grid-gap')) || 12;
        const fractions = getEditorialColumnFractions();
        const columnCount = fractions.length;
        const totalFraction = fractions.reduce((sum, fraction) => sum + fraction, 0);
        const usableWidth = gridWidth - gap * (columnCount - 1);

        if (gridWidth <= 0 || usableWidth <= 0 || totalFraction <= 0) return;

        let x = 0;
        const columns = fractions.map((fraction) => {
          const width = usableWidth * (fraction / totalFraction);
          const column = { x, width, height: 0 };
          x += width + gap;
          return column;
        });

        items.forEach((item) => {
          let bestColumnIndex = 0;
          let bestY = columns[0].height;

          for (let columnIndex = 1; columnIndex < columnCount; columnIndex += 1) {
            const y = columns[columnIndex].height;

            if (y < bestY - 0.5) {
              bestColumnIndex = columnIndex;
              bestY = y;
            }
          }

          const column = columns[bestColumnIndex];
          const itemWidth = column.width;
          const itemHeight = getEditorialItemHeight(item, itemWidth);
          const bottom = bestY + itemHeight;

          item.style.setProperty('--lookbook-item-width', `${itemWidth}px`);
          item.style.setProperty('--lookbook-item-x', `${column.x}px`);
          item.style.setProperty('--lookbook-item-y', `${bestY}px`);
          item.style.setProperty('--lookbook-product-frame-height', `${getGalleryProductFrameHeight(item, itemWidth)}px`);
          item.style.height = `${itemHeight}px`;
          column.height = bottom + gap;
        });

        const layoutHeight = Math.max(...columns.map((column) => column.height)) - gap;
        grid.style.height = `${Math.max(0, layoutHeight)}px`;
        grid.dataset.lookbookLayoutReady = 'true';
      };

      let layoutFrame = null;
      const scheduleEditorialMasonryLayout = () => {
        if (layoutFrame !== null) cancelAnimationFrame(layoutFrame);
        layoutFrame = requestAnimationFrame(() => {
          layoutFrame = null;
          layoutEditorialMasonry();
        });
      };

      items.forEach((item) => {
        const photo = item.querySelector('.lookbook-gallery__image-link > img, img');
        if (!photo) return;

        if (!photo.complete) {
          photo.addEventListener('load', scheduleEditorialMasonryLayout, { once: true });
          photo.addEventListener('error', scheduleEditorialMasonryLayout, { once: true });
        }
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(scheduleEditorialMasonryLayout).observe(grid);
      } else {
        window.addEventListener('resize', scheduleEditorialMasonryLayout);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleEditorialMasonryLayout).catch(() => {});
      }

      scheduleEditorialMasonryLayout();
      gallery.dataset.lightboxReady = 'true';

      const normalizeIndex = (index) => (index + items.length) % items.length;
      const photoHash = (index) => 'lookbook-' + String(index + 1).padStart(2, '0');
      const isLookbookHash = () => /^#lookbook-\d{1,3}$/.test(window.location.hash);

      const parseHashIndex = () => {
        const match = window.location.hash.match(/^#lookbook-(\d{1,3})$/);
        if (!match) return null;
        const index = Number(match[1]) - 1;
        if (!Number.isInteger(index) || index < 0 || index >= items.length) return null;
        return index;
      };

      const urlWithHash = (index) => {
        const url = new URL(window.location.href);
        url.hash = photoHash(index);
        return url;
      };

      const urlWithoutLookbookHash = () => {
        const url = new URL(window.location.href);
        if (isLookbookHash()) url.hash = '';
        return url;
      };

      const writePhotoUrl = (index, replace) => {
        const nextUrl = urlWithHash(index);
        if (window.location.hash === '#' + photoHash(index)) return;
        const state = { lookbookIndex: index };

        if (replace) {
          history.replaceState(state, '', nextUrl);
        } else {
          history.pushState(state, '', nextUrl);
        }
      };

      const clearPhotoUrl = () => {
        if (!isLookbookHash()) return;
        history.pushState({ lookbookIndex: null }, '', urlWithoutLookbookHash());
      };

      const getImage = () => {
        if (image) return image;
        image = document.createElement('img');
        image.className = 'lookbook-lightbox__image';
        image.setAttribute('data-lookbook-image', '');
        image.decoding = 'async';
        image.alt = '';
        imageSlot.appendChild(image);
        return image;
      };

      const preload = (index) => {
        const item = items[normalizeIndex(index)];
        const url = itemUrl(item);
        if (!url) return;
        const preloadImage = new Image();
        preloadImage.src = url;
      };

      const renderProduct = (item) => {
        productSlot.replaceChildren();
        const productStack = item.querySelector('.lookbook-gallery__product-stack');

        if (productStack) {
          const clone = productStack.cloneNode(true);
          clone.classList.add('lookbook-lightbox__product-stack');
          clone.classList.remove('lookbook-gallery__product-stack');
          clone.querySelectorAll('.lookbook-gallery__product-card').forEach((card) => {
            card.classList.add('lookbook-lightbox__product-card');
            card.classList.remove('lookbook-gallery__product-card');
          });
          productSlot.appendChild(clone);
          productSlot.hidden = false;
          return;
        }

        const productCard = item.querySelector('.lookbook-gallery__product-card');

        if (!productCard) {
          productSlot.hidden = true;
          clearMobileLightboxProductPosition();
          return;
        }

        const clone = productCard.cloneNode(true);
        clone.classList.add('lookbook-lightbox__product-card');
        clone.classList.remove('lookbook-gallery__product-card');
        productSlot.appendChild(clone);
        productSlot.hidden = false;
      };

      const render = (index, options = {}) => {
        activeIndex = normalizeIndex(index);
        const item = items[activeIndex];
        const itemImage = item.querySelector('img');
        const url = itemUrl(item);
        const activeImage = getImage();

        activeImage.onload = scheduleMobileLightboxProductPosition;
        activeImage.src = url;
        activeImage.alt = itemImage ? itemImage.alt : '';
        counter.textContent = `${activeIndex + 1} / ${items.length}`;
        renderProduct(item);
        scheduleMobileLightboxProductPosition();
        preload(activeIndex + 1);
        preload(activeIndex - 1);

        if (options.updateUrl) writePhotoUrl(activeIndex, options.replaceUrl);
      };

      const lockPage = () => {
        lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
        document.documentElement.style.setProperty('--lookbook-scroll-y', `${lockedScrollY}px`);
        document.documentElement.classList.add('lookbook-lightbox-open', 'lookbook-lightbox-suppress-initial-focus');
      };

      const unlockPage = () => {
        document.documentElement.classList.remove('lookbook-lightbox-open', 'lookbook-lightbox-suppress-initial-focus');
        document.documentElement.style.removeProperty('--lookbook-scroll-y');
        window.scrollTo(0, lockedScrollY);
      };

      const openAt = (index, trigger, options = {}) => {
        activeTrigger = trigger || document.activeElement;
        render(index, { updateUrl: options.updateUrl, replaceUrl: options.replaceUrl });

        if (!dialog.open) {
          lockPage();

          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        }

        if (closeButton && typeof closeButton.focus === 'function') closeButton.focus({ preventScroll: true });
      };

      const close = (options = {}) => {
        if (options.updateUrl) clearPhotoUrl();

        if (dialog.open && typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          dialog.dispatchEvent(new Event('close'));
        }
      };

      const showPrevious = () => {
        render(activeIndex - 1, { updateUrl: true });
      };
      const showNext = () => {
        render(activeIndex + 1, { updateUrl: true });
      };

      items.forEach((item, index) => {
        item.addEventListener('click', (event) => {
          const target = event.target;

          if (target instanceof Element && target.closest('.lookbook-gallery__product-card')) {
            return;
          }

          event.preventDefault();
          openAt(index, item, { updateUrl: true });
        });
      });

      dialog.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        if (target.closest('[data-lookbook-close]')) {
          close({ updateUrl: true });
          return;
        }

        if (target.closest('[data-lookbook-prev]')) {
          showPrevious();
          return;
        }

        if (target.closest('[data-lookbook-next]')) {
          showNext();
          return;
        }

        if (target.classList.contains('lookbook-lightbox__stage')) close({ updateUrl: true });
      });

      dialog.addEventListener('cancel', () => {
        clearPhotoUrl();
      });

      dialog.addEventListener('close', () => {
        unlockPage();
        if (image) image.removeAttribute('src');
        if (image) image.alt = '';
        counter.textContent = '';
        productSlot.replaceChildren();
        productSlot.hidden = true;
        clearMobileLightboxProductPosition();
        if (!closingFromHistory && activeTrigger && typeof activeTrigger.focus === 'function') activeTrigger.focus({ preventScroll: true });
        closingFromHistory = false;
      });

      document.addEventListener('keydown', (event) => {
        if (!dialog.open) return;

        if (event.key === 'Tab') {
          document.documentElement.classList.remove('lookbook-lightbox-suppress-initial-focus');
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showPrevious();
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showNext();
        }
      }, true);

      dialog.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      dialog.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;

        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        if (deltaX > 0) showPrevious();
        if (deltaX < 0) showNext();
      }, { passive: true });

      window.addEventListener('popstate', () => {
        const index = parseHashIndex();

        if (index !== null) {
          if (dialog.open) {
            render(index);
          } else {
            openAt(index, null);
          }
          return;
        }

        if (dialog.open) {
          closingFromHistory = true;
          close();
        }
      });

      const initialIndex = parseHashIndex();
      if (initialIndex !== null) {
        history.replaceState({ lookbookIndex: initialIndex }, '', urlWithHash(initialIndex));
        window.setTimeout(() => openAt(initialIndex, null), 0);
      }
    };

    document.querySelectorAll('[data-lookbook-gallery]').forEach(initLookbookGallery);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-lookbook-gallery]').forEach(initLookbookGallery);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
